import React from "react"
import { useDropzone } from "react-dropzone"
import PropTypes from "prop-types"

// Import SVG icons
import { ReactComponent as ImageColorIcon } from "assets/icons/image-color.svg"

const ImageUpload = ({ initFile, message, accept, maxSize, onFileChange }) => {
  const [image, setImage] = React.useState(initFile || null)

  const onDrop = React.useCallback(
    acceptedFiles => {
      const file = acceptedFiles[0]
      if (file) {
        const reader = new FileReader()
        reader.onloadend = () => {
          setImage(reader.result)
          if (onFileChange) {
            onFileChange(file)
          }
        }
        reader.readAsDataURL(file)
      }
    },
    [onFileChange]
  )

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/*": accept.split(",").map(type => "." + type.trim().toLowerCase()),
    },
    maxSize: maxSize,
    multiple: false,
    onDropRejected: rejectedFiles => {
      rejectedFiles.forEach(rejection => {
        if (rejection.errors[0].code === "file-too-large") {
          alert(
            `ไฟล์ ${
              rejection.file.name
            } มีขนาดใหญ่เกินไป (สูงสุด ${formatFileSize(maxSize)})`
          )
        }
      })
    },
  })

  // Format file size to human readable format
  const formatFileSize = size => {
    if (size === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB"]
    const i = Math.floor(Math.log(size) / Math.log(k))
    return parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
  }

  React.useEffect(() => {
    setImage(initFile)
  }, [initFile])

  return (
    <div
      {...getRootProps()}
      className="dropzone-image"
      style={image ? { backgroundImage: `url(${image})` } : {}}
    >
      <input {...getInputProps()} />
      {!image ? (
        <>
          <ImageColorIcon
            style={{
              width: 80,
              height: 80,
              marginBottom: 8,
            }}
          />
          <h3 className="mb-2 fw-semibold">{message}</h3>
          <div className="text-muted small">
            <h6 className="text-primary-600">
              รองรับชนิดไฟล์ดังนี้ : {accept}
            </h6>
            {/* <span className="text-md">
              ขนาดไฟล์สูงสุด: {formatFileSize(maxSize)}
            </span> */}
          </div>
        </>
      ) : (
        <div className="overlay">คลิกหรือลากไฟล์เพื่อเปลี่ยนรูปภาพ</div>
      )}
    </div>
  )
}

ImageUpload.propTypes = {
  initFile: PropTypes.string,
  message: PropTypes.string.isRequired,
  accept: PropTypes.string.isRequired,
  maxSize: PropTypes.number.isRequired,
  onFileChange: PropTypes.func,
}

export default ImageUpload
